<template>
  <section class="embroidery-main-view">
    <h5 class="embroidery-main-view-title text-center">{{ translations.embroideryMainViewStep }}</h5>
    <span v-show="!!isPersonalizationInvalid">{{ translations.transferDesignEmbroideryDesc }}</span>
    <images-view
      :itemsToPersonalize="itemsToPersonalize"
      @images-loaded="imagesLoaded"
    ></images-view>

    <div class="row">
      <div :class="['small-8', 'large-6', 'small-centered', 'columns', {'large-uncentered': itemsToPersonalize > 1}]" >
        <label
          v-tooltip="{
            placement: 'top-center',
            trigger: 'manual',
            show: showModerationMessage0,
            classes: 'embroidery-main-view-label-tooltip',
            content: moderationMessage,
            container: false
          }"
          class="embroidery-main-view-label"
          for="input-text-personalization-left"
        >
          <span v-if="itemsToPersonalize > 1"> {{ translations.embroideryLeftShoeLabel }}</span>
          <span v-else>{{ translations.embroideryBackpackLabel }}</span>
        </label>
        <input
          v-model.trim="message0"
          @input="validateInputText"
          :maxlength="maxLength(0)"
          :class="['embroidery-main-view-input', 'uppercase', { 'error-moderation': showModerationMessage0 }]"
          type="text"
          data-slide-id="0"
          name="personlization-input-left"
          id="input-text-personalization-left"
          ref="personlizationInputLeft"
        />
      </div>

      <div v-if="itemsToPersonalize > 1" class="small-8 large-6 small-centered large-uncentered columns">
        <label
          v-tooltip="{
            placement: 'top-center',
            trigger: 'manual',
            show: showModerationMessage1,
            classes: 'embroidery-main-view-label-tooltip',
            content: moderationMessage,
            container: false
          }"
          class="embroidery-main-view-label"
          for="input-text-personalization-right"
        >
          {{ translations.embroideryRightShoeLabel }}
        </label>
        <input
          v-model.trim="message1"
          @input="validateInputText"
          :maxlength="maxLength(1)"
          :class="['embroidery-main-view-input', 'uppercase', { 'error-moderation': showModerationMessage1 }]"
          type="text"
          data-slide-id="1"
          name="personlization-input-right"
          id="input-text-personalization-right"
        />
      </div>
    </div>

    <div class="embroidery-main-view-alpha-num text-center">{{ translations.personalizeAlphaNum }}</div>
  </section>
</template>

<script>
import imagesView from '@/components/Embroidery/ImagesView';

import mainView from '@/mixins/Embroidery/MainView';

export default {
  name: 'embroideryMainView',
  mixins: [mainView],
  components: {
    imagesView
  },
  mounted () {
    this.$refs.personlizationInputLeft.focus();
  },
};
</script>
